import React from 'react';
import { useSelector } from 'react-redux';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import {
  ChatWidgetTroubleshootingToolResultTypes,
  Result,
} from '../ChatWidgetTroubleshootingToolResult';

export const useWpRocketCombinedJSResult = (): Result => {
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  if (!result) {
    return;
  }

  if (result.errors.wpRocketCombinedJSDetected) {
    return {
      result: 'error',
      type: ChatWidgetTroubleshootingToolResultTypes.WpRocketCombinedJSResult,
      description: (
        <>
          Your website may be using WP Rocket to&nbsp;
          <i>Combine JavaScript Files</i>. This can prevent the chat widget from
          updating properly. If your chat widget is not appearing correctly,
          please try&nbsp;
          <a href="https://docs.wp-rocket.me/article/53-clear-wp-rocket-cache">
            clearing the WP Rocket cache
          </a>
          . To prevent this issue from happening again, you can also&nbsp;
          <a href="https://docs.wp-rocket.me/article/39-excluding-external-js-from-concatenation">
            exclude the chat widget script from concatenation
          </a>
          .
        </>
      ),
    };
  }
};
